import { isWeb } from '@mythical/ui'
import { ContentView } from 'app/components/content/ContentView'
import { KeyboardAwareScrollView } from 'app/components/primitive/KeyboardAwareScrollView'
import MainLayout from 'app/components/structure/Layout/MainLayout'
import { createParam } from 'solito'
import React from 'react'
import { Content } from 'app/queries/content/content'

type ContentViewParams = {
  slug: string
  content?: string
  series?: string
  id?: string
  preview?: string
  token?: string
}

const { useParam } = createParam<ContentViewParams>()

interface ContentViewScreenProps {
  content?: Content
  series?: string
}

export function ContentViewScreen({ content }: ContentViewScreenProps) {
  const [slugParam] = useParam('slug')
  const [id] = useParam('id')
  const [preview] = useParam('preview')
  const [token] = useParam('token')
  const [series] = useParam('series')
  const [contentSlug] = useParam('content')

  const isPreview = preview === 'true'
  const scrollRef = React.useRef<KeyboardAwareScrollView>(null)

  const scrollToTop = () => {
    if (!scrollRef.current || isWeb) return
    scrollRef.current.scrollToPosition(0, 0, true)
  }

  const slug = contentSlug || slugParam

  return (
    <MainLayout
      contentStyles={{
        bg: '$secondary10',
        flex: 1
      }}
      showBackBtn
      noBottomTabs
      scrollRef={scrollRef}
    >
      <ContentView
        content={content}
        series={series}
        id={id || ''}
        slug={slug || ''}
        preview={isPreview}
        token={token}
        scrollToTop={scrollToTop}
      />
    </MainLayout>
  )
}
